import React from "react";

export default function CustomButton({
  label = "Add Event",
  icon: Icon,
  iconPos = "right", // "left" | "right"
  onClick,
  variant = "solid", // "solid" | "outline"
  color = "#02a9e0", // Any hex or tailwind color
  disabled = false,
  className = "",
  borderColor = "#02a9e0", // For outline variant
  type="button"
}) {
  const isOutline = variant === "outline";
  const buttonStyles = {
        borderRadius: "8px",
        padding: "10px 16px",
        gap: "8px",
        borderWidth: "1px",
        borderColor: isOutline ? "var(--color-primary)" : "transparent",
        backgroundColor: isOutline ? "transparent" : "var(--color-primary)",
        color: isOutline ? "var(--secondary-colour)" : "#ffffff",
      }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      style={className?{className}: buttonStyles}
      className={`inline-flex items-center justify-center font-semibold text-[12px] transition-all duration-150 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {/* Icon on Left */}
      {Icon && iconPos === "left" && (
        <span className="flex items-center text-[16px]">
          <Icon />
        </span>
      )}

      {/* Button Text */}
      <span>{label}</span>

      {/* Icon on Right */}
      {Icon && iconPos === "right" && (
        <span className="flex items-center text-[16px]">
          <Icon />
        </span>
      )}
    </button>
  );
}